module.exports = __webpack_public_path__ + "img/Mini_skip reversed.3083d008.png";